import React from "react";
import { Gift, X } from "lucide-react";
import { useReferral } from "../context/ReferralContext";

export function ReferralModal() {
  const { showBanner, referralData, dismissBanner } = useReferral();

  if (!showBanner || !referralData) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-sm animate-fade-in"
      data-testid="referral-modal"
    >
      <div className="relative w-full max-w-md bg-white rounded-2xl overflow-hidden soft-shadow-lg animate-scale-in">
        <div className="h-1.5 w-full bg-brand" />
        <button
          onClick={dismissBanner}
          data-testid="referral-modal-close"
          className="absolute top-4 right-4 text-navy-soft hover:text-navy transition-colors"
          aria-label="Chiudi"
        >
          <X className="w-5 h-5" />
        </button>
        <div className="p-8">
          <div className="w-14 h-14 rounded-2xl bg-brand-light text-brand-darker flex items-center justify-center mb-5">
            <Gift className="w-7 h-7" />
          </div>
          <div className="label-eyebrow text-brand-dark mb-2">Offerta riservata</div>
          <h2 className="font-heading font-extrabold text-2xl text-navy leading-tight" data-testid="referral-modal-title">
            {referralData.custom_banner_title || "Benvenuto!"}
          </h2>
          <p className="mt-3 text-navy-soft leading-relaxed text-sm" data-testid="referral-modal-message">
            {referralData.custom_banner_message ||
              "Hai diritto a un buono sconto speciale se attivi un servizio tramite questo link."}
          </p>

          {(referralData.bonus_type || referralData.discount_value) && (
            <div className="mt-5 rounded-xl bg-brand-light px-4 py-3.5 flex items-center gap-3">
              <Gift className="w-5 h-5 text-brand-darker shrink-0" />
              <div className="text-sm leading-tight">
                <div className="text-navy-soft text-xs">Attivando un servizio ricevi</div>
                <div className="font-bold text-brand-darker">
                  {[referralData.bonus_type, referralData.discount_value].filter(Boolean).join(" ")}
                </div>
              </div>
            </div>
          )}

          <div className="mt-4 text-xs text-navy-soft">
            Codice: <span className="font-mono font-semibold text-navy">{referralData.code}</span>
          </div>

          <button
            onClick={dismissBanner}
            data-testid="referral-modal-continue"
            className="mt-6 w-full bg-brand hover:bg-brand-dark text-white font-bold py-3 rounded-full transition-colors soft-shadow"
          >
            Continua
          </button>
        </div>
      </div>
    </div>
  );
}
